import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../../context/AppContext";
import { useI18n } from "../../i18n";
import { priceLines, readCustomerCart, writeCustomerCart } from "../../services/commerce";
import { Button, Card, EmptyState, Qty, Skeleton, baht, useAsync } from "../../components/ui";
import Icon from "../../components/ui/Icon";

export default function Cart() {
  const navigate = useNavigate();
  const { orgId } = useApp();
  const { tx } = useI18n();
  // ตะกร้าเก็บแค่ productId + จำนวน (แยกต่อร้าน) — ชื่อ/ราคาอ่านจากระบบทุกครั้งที่แสดง
  const [rows, setRows] = useState(() => readCustomerCart(orgId));

  useEffect(() => {
    setRows(readCustomerCart(orgId));
    const sync = () => setRows(readCustomerCart(orgId));
    window.addEventListener("cart-change", sync);
    return () => window.removeEventListener("cart-change", sync);
  }, [orgId]);

  const key = rows.map((row) => `${row.productId}:${row.quantity}`).join(",");
  const { data: priced, loading } = useAsync(() => priceLines(orgId, rows), [orgId, key], { lines: [], total: 0, missing: [] });

  // สินค้าที่ถูกปิดขาย/ลบไปแล้ว เอาออกจากตะกร้า
  useEffect(() => {
    if (!loading && priced.missing.length) {
      const next = rows.filter((row) => !priced.missing.includes(row.productId));
      writeCustomerCart(orgId, next);
      setRows(next);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, priced]);

  const setQty = (productId, value) => {
    const next = value <= 0 ? rows.filter((row) => row.productId !== productId) : rows.map((row) => (row.productId === productId ? { ...row, quantity: value } : row));
    writeCustomerCart(orgId, next);
    setRows(next);
  };

  if (rows.length === 0) return <EmptyState icon={<Icon name="cart" />} text={tx("ตะกร้าว่างเปล่า", "Your cart is empty")} action={<Button variant="primary" onClick={() => navigate("/app/store")}>{tx("เลือกสินค้า", "Browse services")}</Button>} />;
  if (loading && !priced.lines.length) return <Skeleton height={120} />;

  return (
    <>
      {priced.lines.map((row) => (
        <Card key={row.productId}>
          <div className="u-between">
            <div>
              <div className="u-strong">{row.name}</div>
              <div className="u-fs-13 u-muted">{baht(row.price, 0)}</div>
            </div>
            <Qty value={row.quantity} onChange={(value) => setQty(row.productId, value)} />
          </div>
        </Card>
      ))}

      <Card>
        <div className="u-between" style={{ fontSize: 18, fontWeight: 800 }}>
          <span>{tx("รวม", "Total")}</span>
          <span>{baht(priced.total)}</span>
        </div>
      </Card>

      <Button variant="primary" block onClick={() => navigate("/app/checkout")}>
        {tx("ไปหน้าชำระเงิน", "Proceed to checkout")}
      </Button>
    </>
  );
}
